import agent from "../../../api/agent";
export const list = (pagerInputModel) =>
  agent.requests.post(`/template/GetPagedList`, pagerInputModel);
export const create = (template) => agent.requests.post(`/template/create`, template);
export const update = (template) => agent.requests.post(`template/update`, template);


export const sendEmail = (emailPar) => agent.requests.post(`CustomerEmail/SendEmailWithSendinblue`, emailPar);
